import React, { useEffect, useRef } from 'react';

const RazorpayButton = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    // Clear any previous content
    containerRef.current.innerHTML = '';

    // Create form element
    const form = document.createElement('form');

    // Create script element
    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/payment-button.js';
    script.setAttribute('data-payment_button_id', 'pl_R1XEKH1FixBw5J');
    script.async = true;

    // Append script to form, then form to container
    form.appendChild(script);
    containerRef.current.appendChild(form);
  }, []);

  return <div ref={containerRef}></div>;
};

export default RazorpayButton;
